import React from "react";
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import ViewUserProfile from "./ViewUserProfile";
import ButtonManagment from "./ButtonManagment";
import BackButton from "@/components/widgets/common/BackButton";
import HeaderComponent from "@/components/Header/Header";
import { BodyContainer, Container } from "@/styles/ContainerStyles";

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "Profile",
    children: <ViewUserProfile />,
  },
  {
    key: "2",
    label: "Buttons",
    children: <ButtonManagment />,
  },
];

const ManageUserProfile: React.FC = () => (
  <div className="w-full h-full">
    <Container className="w-full h-full">
      <BodyContainer className="w-full h-full">
        <div className="flex flex-row justify-start w-full align-items-center">
          <BackButton />
          <HeaderComponent title="Manage User Profile" />
        </div>
        <Tabs defaultActiveKey="1" items={items} className="ml-4" />
      </BodyContainer>
    </Container>
  </div>
);

export default ManageUserProfile;
